module.exports = __webpack_public_path__ + "static/img/new_powrbank_phone.9fd9a10f.png";